export default __webpack_public_path__ + "assets/fonts/Nunito-Light-7f6244ab.woff";